import ReservationCheckSvg from '@assets/images/svg/reservation-check.svg';
import React from 'react';
import { View } from 'react-native';

export interface ReservationCheckIconProps {
  size?: number;
  color?: string;
}

/** Figma reservation confirmed — outline circle-check (~16.67, stroke 1.33) */
export function ReservationCheckIcon({
  size = 16.67,
  color = '#388E3C',
}: Readonly<ReservationCheckIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ReservationCheckSvg width={size} height={size} color={color} />
    </View>
  );
}

export default ReservationCheckIcon;
